(function() {
  define('bazemont/event/home',['jquery', 'angular'], function($) {
    'use strict';
    return angular.module('bazemontEventHome', []).component('bazemontEventHome', {
      templateUrl: '/assets/javascripts/bazemont/event/home.html',
      controller: [
        '$http', '$scope', '$timeout', function($http, $scope, $timeout) {
          var getDayClass, handleSelectedDateChange, setDateTooltips, vm;
          vm = this;
          vm.disabled = true;
          vm.currentMonth = new Date().getMonth();
          vm.currentYear = new Date().getFullYear();
          vm.eventDatesToTitles = new Map();
          vm.selectedMonth = function(event) {
            var endsOn, eventDate;
            eventDate = new Date(event.eventDate);
            endsOn = event.endsOn ? new Date(event.endsOn) : null;
            return (eventDate.getFullYear() === vm.currentYear && eventDate.getMonth() === vm.currentMonth) || (endsOn && endsOn.getFullYear() === vm.currentYear && endsOn.getMonth() === vm.currentMonth);
          };
          getDayClass = function(data) {
            var className, currentDate, date, event, eventDate, mode, today, _i, _len, _ref;
            className = '';
            mode = data.mode;
            if (mode === 'day') {
              date = data.date;
              currentDate = new Date(date).setHours(0, 0, 0, 0);
              today = new Date().setHours(0, 0, 0, 0);
              if (today === currentDate) {
                className = 'today ';
              }
              if (vm.events) {
                _ref = vm.events;
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                  event = _ref[_i];
                  eventDate = new Date(event.eventDate).setHours(0, 0, 0, 0);
                  if (currentDate === eventDate) {
                    className += 'highlight';
                    break;
                  }
                }
              }
            }
            return className;
          };
          vm.datepickerOptions = {
            showWeeks: false,
            startingDay: 1,
            customClass: getDayClass
          };
          setDateTooltips = function(eventDatesToTitles) {
            return $timeout(function() {
              return $('.uib-day.highlight').each(function(index, element) {
                var day, daySpan, eventTitle, highlightedDate, month, year;
                daySpan = $(element).find('button span');
                day = daySpan.text();
                month = vm.currentMonth;
                year = vm.currentYear;
                if ($(daySpan).hasClass('text-muted')) {
                  month = day < 15 ? month + 1 : month - 1;
                }
                highlightedDate = new Date(year, month, day);
                eventTitle = eventDatesToTitles.get(highlightedDate.getTime());
                return $(element).attr('title', eventTitle);
              });
            });
          };
          vm.$onInit = function() {
            return $http.get('/api/events/list').then(function(response) {
              vm.events = response.data;
              vm.disabled = false;
              vm.eventDatesToTitles = new Map(vm.events.map(function(event) {
                return [new Date(event.eventDate).setHours(0, 0, 0, 0), event.title];
              }));
              setDateTooltips(vm.eventDatesToTitles);
              $('.uib-right').on('click', function() {
                if (vm.currentMonth >= 11) {
                  vm.currentMonth = 0;
                  vm.currentYear++;
                } else {
                  vm.currentMonth++;
                }
                setDateTooltips(vm.eventDatesToTitles);
                return $scope.$apply();
              });
              return $('.uib-left').on('click', function() {
                if (vm.currentMonth <= 0) {
                  vm.currentMonth = 11;
                  vm.currentYear--;
                } else {
                  vm.currentMonth--;
                }
                setDateTooltips(vm.eventDatesToTitles);
                return $scope.$apply();
              });
            });
          };
          vm.isRegistrationAllowed = function(event) {
            var now;
            now = new Date();
            return event.hasRegistration && (event.eventDate > now || (event.endsOn && event.endsOn > now));
          };
          handleSelectedDateChange = function(date) {
            var myElement, timestamp, topPos;
            if (date) {
              timestamp = date.getTime();
              myElement = document.getElementById('event-' + timestamp);
              if (myElement) {
                topPos = myElement.offsetTop;
                document.getElementById('event-list').scrollTop = topPos;
                return setDateTooltips(vm.eventDatesToTitles);
              }
            }
          };
          $scope.$watch(function() {
            return vm.selectedDate;
          }, handleSelectedDateChange);
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=home.js.map
;
